import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy, Calculator, ExternalLink, ArrowRight } from 'lucide-react';
import { ROICalculator } from '../ROICalculator';

const PLAN_FEATURES = {
  trainingClub: ['Brand rights & marketing', 'Gym Finder listing', 'HYROX365 Performance Hub', 'Coach certification access', 'Host Race Sims & PFTs', 'Member pre-release event access'],
  performance: ['Everything in Training Club', 'Geographic area exclusivity', 'Official CENTR equipment', '~2,000 sq ft dedicated space', 'Premium Gym Finder placement', 'Race-day condition replication'],
};

const APPLY_STEPS = [
  { step: '1', title: 'Create Account', desc: 'Sign up at portal.hyrox365.com' },
  { step: '2', title: 'Add Your Gym', desc: 'Build your business profile and add location' },
  { step: '3', title: 'Choose & Pay', desc: 'Select Training Club or Performance Centre' },
];

export const AffiliateSection = () => (
  <section id="affiliate" className="bg-[#050505] section-spacing" data-testid="hyrox-affiliate-section">
    <div className="container-ninja">
      <div className="max-w-4xl mx-auto">
        <p className="text-[#e8ff00] text-xs uppercase tracking-wider font-heading mb-3 flex items-center gap-2">
          <Trophy className="w-4 h-4" /> For Gym Owners
        </p>
        <h2 className="text-3xl md:text-4xl text-white font-heading mb-4">Become a HYROX Affiliate Gym</h2>
        <p className="text-zinc-400 mb-8 max-w-2xl">
          Join 9,000+ gyms worldwide. Get listed in the official gym finder, access programming, coach education, and the right to use the HYROX brand.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          <div className="bg-zinc-900/80 border border-[#e8ff00]/20 p-6">
            <h3 className="text-[#e8ff00] font-heading text-xl mb-3">Training Club</h3>
            <p className="text-3xl font-heading text-white mb-1">$130<span className="text-zinc-500 text-sm">/mo</span></p>
            <p className="text-zinc-500 text-xs mb-4">or ~$1,500/year</p>
            <ul className="space-y-2 text-sm text-zinc-400">
              {PLAN_FEATURES.trainingClub.map((f) => (
                <li key={f} className="flex items-center gap-2"><span className="text-green-500">&#10003;</span> {f}</li>
              ))}
            </ul>
          </div>
          <div className="bg-zinc-900/80 border border-blue-500/20 p-6">
            <h3 className="text-blue-400 font-heading text-xl mb-3">Performance Centre</h3>
            <p className="text-3xl font-heading text-white mb-1">Custom<span className="text-zinc-500 text-sm"> quote</span></p>
            <p className="text-zinc-500 text-xs mb-4">Premium tier for dedicated facilities</p>
            <ul className="space-y-2 text-sm text-zinc-400">
              {PLAN_FEATURES.performance.map((f) => (
                <li key={f} className="flex items-center gap-2"><span className="text-blue-400">&#10003;</span> {f}</li>
              ))}
            </ul>
          </div>
        </div>

        <h3 className="text-white font-heading text-xl mb-4 flex items-center gap-2">
          <Calculator className="w-5 h-5 text-[#e8ff00]" /> ROI Calculator
        </h3>
        <ROICalculator />

        <div className="mt-8 bg-zinc-900/80 border border-zinc-800 p-6">
          <h3 className="text-white font-heading text-lg mb-4">How to Apply</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {APPLY_STEPS.map((s) => (
              <div key={s.step} className="flex items-start gap-3">
                <span className="w-8 h-8 flex items-center justify-center bg-[#e8ff00] text-black font-heading font-bold flex-shrink-0 text-sm">{s.step}</span>
                <div>
                  <p className="text-white text-sm font-medium">{s.title}</p>
                  <p className="text-zinc-500 text-xs">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <a
            href="https://portal.hyrox365.com/signup"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-[#e8ff00] text-black font-heading text-sm uppercase tracking-wider hover:opacity-90 transition-opacity"
            data-testid="apply-hyrox-btn"
          >
            Apply on HYROX365 <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        <div className="mt-4 text-center">
          <Link
            to="/blogs/article/how-to-become-a-hyrox-affiliate-gym-2026-classes-costs-equipment-guide"
            className="text-[#e8ff00] text-sm font-heading uppercase tracking-wider inline-flex items-center gap-2 hover:text-white transition-colors"
            data-testid="full-affiliate-guide-link"
          >
            Read Full Affiliate Guide <ArrowRight className="w-3 h-3" />
          </Link>
        </div>
      </div>
    </div>
  </section>
);
